(() => {
    const cartRoots = document.querySelectorAll('[data-fls-cart], [data-fls-cart-page]');
    if (!cartRoots.length) return;

    // Drawer (slide-out) і фон
    const drawerRoot = document.querySelector('[data-fls-cart]');
    const cartBg = document.querySelector('.cart__bg') || null;

    // Формат грошей беремо з першого кореня
    const firstRoot = cartRoots[0];
    const moneyFormatAttr = firstRoot.getAttribute('data-money-format');
    const moneyFormat =
        moneyFormatAttr && moneyFormatAttr.trim() ? moneyFormatAttr.trim() : '{{amount}}';

    const formatMoney = (cents) => {
        const intCents = parseInt(cents, 10) || 0;

        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(intCents, moneyFormat);
        }

        const value = (intCents / 100).toFixed(2);

        if (moneyFormat.indexOf('{{amount}}') !== -1) {
            return moneyFormat.replace('{{amount}}', value);
        }

        return value;
    };

    const renderCartForRoot = (root, cart) => {
        const bodyEl = root.querySelector('.cart__body');
        const titleEl = root.querySelector('.cart__title');
        const subtotalEl = root.querySelector('[data-cart-subtotal]');
        const checkoutBtn = root.querySelector('.cart__button');
        const count = cart.item_count || 0;

        if (titleEl) {
            titleEl.textContent = `Your cart (${count})`;
        }

        if (!bodyEl) return;

        if (count === 0) {
            bodyEl.innerHTML = `
                <div class="cart__empty">
                    ${
                        typeof Shopify !== 'undefined' &&
                        Shopify.translation &&
                        Shopify.translation['cart.general.empty']
                            ? Shopify.translation['cart.general.empty']
                            : 'Your cart is empty.'
                    }
                </div>
            `;
        } else {
            const itemsHtml = cart.items
                .map((item) => {
                    const unitPrice =
                        item.final_line_price && item.quantity
                            ? formatMoney(item.final_line_price / item.quantity)
                            : formatMoney(item.price);

                    const linePrice = formatMoney(item.final_line_price);

                    const imageSrc =
                        item.image || (item.featured_image && item.featured_image.url) || '';
                    const imageAlt =
                        (item.featured_image && item.featured_image.alt) ||
                        item.product_title ||
                        '';

                    const variantTitle =
                        item.variant_title && item.variant_title !== 'Default Title'
                            ? ` – ${item.variant_title}`
                            : '';

                    return `
                        <div
                            class="cart__item"
                            data-cart-item
                            data-cart-item-key="${item.key}"
                        >
                            <div class="cart__content">
                                <div class="cart__image">
                                    <picture>
                                        <img
                                            alt="${imageAlt.replace(/"/g, '&quot;')}"
                                            src="${imageSrc}"
                                        >
                                    </picture>
                                </div>
                                <div class="cart__info">
                                    <h5>${item.product_title}${variantTitle}</h5>
                                    <p data-cart-item-price>${unitPrice}</p>
                                    <div class="cart__counter">
                                        <div
                                            class="cart__minus"
                                            data-cart-qty-minus
                                        >-</div>
                                        <input
                                            type="text"
                                            class="cart__count"
                                            value="${item.quantity}"
                                            data-cart-qty-input
                                            inputmode="numeric"
                                        >
                                        <div
                                            class="cart__plus"
                                            data-cart-qty-plus
                                        >+</div>
                                    </div>
                                </div>
                            </div>
                            <div class="cart__control">
                                <div
                                    class="cart__remove"
                                    data-cart-remove
                                    role="button"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M5.46995 6.01467V18.5287C5.46981 18.886 5.5401 19.2399 5.6768 19.5701C5.8135 19.9003 6.01392 20.2003 6.26661 20.453C6.51931 20.7057 6.81932 20.9061 7.14951 21.0428C7.47969 21.1795 7.83358 21.2498 8.19095 21.2497H15.8089C16.5303 21.2497 17.2222 20.9631 17.7323 20.453C18.2424 19.9429 18.5289 19.2511 18.5289 18.5297V6.01367M3.29395 6.01467H20.7059" stroke="#44413E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.73486 6.015V4.382C8.7346 4.16753 8.77667 3.95511 8.85865 3.75692C8.94064 3.55873 9.06093 3.37867 9.21263 3.22706C9.36434 3.07545 9.54447 2.95527 9.74271 2.87341C9.94094 2.79154 10.1534 2.74961 10.3679 2.75H13.6319C13.8463 2.74961 14.0588 2.79154 14.257 2.87341C14.4553 2.95527 14.6354 3.07545 14.7871 3.22706C14.9388 3.37867 15.0591 3.55873 15.1411 3.75692C15.2231 3.95511 15.2651 4.16753 15.2649 4.382V6.015" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div
                                    class="cart__price"
                                    data-cart-line-price
                                >
                                    ${linePrice}
                                </div>
                            </div>
                        </div>
                    `;
                })
                .join('');

            bodyEl.innerHTML = itemsHtml;
        }

        if (subtotalEl) {
            subtotalEl.textContent = formatMoney(cart.total_price);
        }

        const headerCountEl = document.querySelector('[data-cart-count]');
        if (headerCountEl) {
            headerCountEl.textContent = count;
        }

        if (checkoutBtn) {
            if (count === 0) {
                checkoutBtn.classList.add('cart__button--disabled');
                checkoutBtn.setAttribute('aria-disabled', 'true');
            } else {
                checkoutBtn.classList.remove('cart__button--disabled');
                checkoutBtn.removeAttribute('aria-disabled');
            }
        }
    };

    const refreshCart = () => {
        return fetch('/cart.js', {
            method: 'GET',
            credentials: 'same-origin',
        })
            .then((res) => res.json())
            .then((cart) => {
                cartRoots.forEach((root) => renderCartForRoot(root, cart));
                return cart;
            })
            .catch(() => {
                // тихо ігноруємо помилку
            });
    };

    // ===== Drawer-функції (відкриття/закриття) =====

    const open = () => {
        if (!drawerRoot) return;
        drawerRoot.classList.add('cart--open');
        if (cartBg) cartBg.classList.add('cart__bg--active');
        document.documentElement.classList.add('cart-open');
        refreshCart();
    };

    const close = () => {
        if (!drawerRoot) return;
        drawerRoot.classList.remove('cart--open');
        if (cartBg) cartBg.classList.remove('cart__bg--active');
        document.documentElement.classList.remove('cart-open');
    };

    const toggle = () => {
        if (!drawerRoot) return;
        if (drawerRoot.classList.contains('cart--open')) {
            close();
        } else {
            open();
        }
    };

    const isOpen = () => {
        if (!drawerRoot) return false;
        return drawerRoot.classList.contains('cart--open');
    };

    // Експортуємо у глобал тільки один раз
    window.flsCart = window.flsCart || {};
    if (!window.flsCart.__inited) {
        window.flsCart.open = open;
        window.flsCart.close = close;
        window.flsCart.toggle = toggle;
        window.flsCart.isOpen = isOpen;
        window.flsCart.refresh = refreshCart;
        window.flsCart.__inited = true;
    }

    // ===== Зміна кількості / видалення =====

    const changeItemQuantity = (key, quantity) => {
        const safeQty = quantity < 0 ? 0 : quantity;

        return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: `id=${encodeURIComponent(key)}&quantity=${encodeURIComponent(safeQty)}`,
        })
            .then(() => refreshCart())
            .catch(() => {});
    };

    const handleCartClick = (event, root) => {
        const target = event.target;

        // Закриття тільки для drawer-корзини
        if (root.hasAttribute('data-fls-cart') && target.closest('.cart__close')) {
            close();
            return;
        }

        if (target.closest('.cart__remove[data-cart-remove]')) {
            const itemEl = target.closest('[data-cart-item]');
            if (!itemEl) return;

            const key = itemEl.getAttribute('data-cart-item-key');
            if (!key) return;

            changeItemQuantity(key, 0);
            return;
        }

        if (target.closest('[data-cart-qty-minus]')) {
            const itemEl = target.closest('[data-cart-item]');
            if (!itemEl) return;

            const key = itemEl.getAttribute('data-cart-item-key');
            const input = itemEl.querySelector('[data-cart-qty-input]');
            if (!key || !input) return;

            const current = parseInt(input.value, 10) || 0;
            const next = current - 1;

            changeItemQuantity(key, next);
            return;
        }

        if (target.closest('[data-cart-qty-plus]')) {
            const itemEl = target.closest('[data-cart-item]');
            if (!itemEl) return;

            const key = itemEl.getAttribute('data-cart-item-key');
            const input = itemEl.querySelector('[data-cart-qty-input]');
            if (!key || !input) return;

            const current = parseInt(input.value, 10) || 0;
            const next = current + 1;

            changeItemQuantity(key, next);
        }
    };

    const handleCartInput = (event, root) => {
        const target = event.target;
        if (!target.matches('[data-cart-qty-input]')) return;

        const itemEl = target.closest('[data-cart-item]');
        if (!itemEl) return;

        const key = itemEl.getAttribute('data-cart-item-key');
        if (!key) return;

        const raw = parseInt(target.value, 10);
        const safe = Number.isNaN(raw) || raw <= 0 ? 1 : raw;

        changeItemQuantity(key, safe);
    };

    // Вішаємо обробники на КОЖНУ версію кошика (drawer + page)
    cartRoots.forEach((root) => {
        root.addEventListener('click', (event) => handleCartClick(event, root));
        root.addEventListener('change', (event) => handleCartInput(event, root));
    });

    // Клік по фону — закрити (тільки drawer)
    if (cartBg && drawerRoot) {
        cartBg.addEventListener('click', () => {
            close();
        });
    }

    // Escape — закрити drawer
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) {
            close();
        }
    });

    // Відкриття drawer по тригеру
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-fls-cart-open]');
        if (!trigger) return;
        event.preventDefault();
        open();
    });

    // Якщо десь add-to-cart кидає cart:updated — оновлюємо всі кошики
    document.addEventListener('cart:updated', () => {
        refreshCart();
    });

    // На сторінці кошика одразу підтягнемо поточний стан
    // (drawer все одно оновлюється при open())
    refreshCart();
})();
